/* eslint-disable prefer-destructuring */
/* eslint-disable no-plusplus */
/* eslint-disable func-names */
import EDC from '../../../shared/globals';
import Answer from '../answer';
import Question from '../question';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsSorting.GameData;
  this.signals = {
    S_ITEM_CORRECT: 'S_ITEM_CORRECT',
    S_ITEM_WRONG: 'S_ITEM_WRONG',
  };
  this.difficulty = 1;
  this.iteration = 0;
  this.itemsData = [];
  this.pastItemsData = [];
  this.answers = [];
  this.question = null;
  this.usedFrameIcons = [];
  this.unusedFrameIcons = [];
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
// eslint-disable-next-line max-len
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.constructor = EDC.Games.ImagesToTextSpace.Scenes.Main;
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.create = function () {
  this.initialize();

  for (let i = 1; i < 7; i++) {
    this.unusedFrameIcons.push(i);
  }

  this.add.sprite(this.game.scale.width / 2, 1020, 'title');

  this.createAnswers();
  this.question = new Question(this).create();
  this.question.place(this.game.scale.width / 2, 800);

  this.events.on(this.signals.S_ITEM_CORRECT, this.onItemCorrect, this);
  this.events.on(this.signals.S_ITEM_WRONG, this.onItemWrong, this);

  this.prepareItemsData();
  this.loadIteration();

  this.createBasicUI();
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.onItemCorrect = function () {
  this.iteration++;
  if (this.iteration > this.gameConfig.sets[this.difficulty].iterations) {
    this.answers.forEach((elem) => {
      elem.makeInteractive(false);
    });
    this.cursorManager.resetCursor();
    this.showSummary();
  } else {
    this.playCorrect();
    this.loadIteration();
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.onItemWrong = function () {
  this.playWrong();
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.prepareItemsData = function () {
  this.itemsData = [];
  const assets = this.gameConfig.assets;
  for (let i = 0; i < assets.length; i++) {
    const item = assets[i];
    this.itemsData.push({ spriteName: `asset-${item.id}`, text: item.text });
  }
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.getUnusedFrameIcon = function () {
  const rndIndex = Math.floor(Math.random() * this.unusedFrameIcons.length);
  const elem = this.unusedFrameIcons.splice(rndIndex, 1);
  Array.prototype.push.apply(this.usedFrameIcons, elem);
  return elem[0];
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.loadIteration = function () {
  const iterationData = [];
  if (this.itemsData.length < this.gameConfig.sets[this.difficulty].itemsCount) {
    Array.prototype.push.apply(this.itemsData, this.pastItemsData);
    this.pastItemsData = [];
  }
  for (let i = 0; i < this.gameConfig.sets[this.difficulty].itemsCount; i++) {
    const rndIndex = Math.floor(Math.random() * this.itemsData.length);
    const elem = this.itemsData.splice(rndIndex, 1);
    Array.prototype.push.apply(iterationData, elem);
  }

  const rndIndex = Math.floor(Math.random() * iterationData.length);
  const correctAnswer = iterationData[rndIndex].text;
  this.question.setData(iterationData[rndIndex]);

  for (let i = 0; i < iterationData.length; i++) {
    const isCorrect = iterationData[i].text === correctAnswer;
    this.answers[i].setData(iterationData[i], isCorrect);
  }

  Array.prototype.push.apply(this.pastItemsData, iterationData);
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Scenes.Main.prototype.createAnswers = function () {
  const baseY = 350;
  const maxDistance = 70;
  const minDistance = 30;
  let direction = -1;
  const count = this.gameConfig.sets[this.difficulty].itemsCount;
  const gameWidth = this.game.scale.width - 200;
  const answerAreaWidth = gameWidth / count;
  const startX = 100;
  for (let i = 0; i < count; i++) {
    const answer = new Answer(this, this.gameConfig).create();
    const x = startX + answerAreaWidth * i + answerAreaWidth / 2;
    const rndDistance = (minDistance + Math.floor(Math.random() * maxDistance)) * direction;
    const y = baseY + rndDistance;
    direction *= -1;
    answer.place(x, y, true);
    answer.place(x, y - 800);
    answer.appear();
    this.answers.push(answer);
  }
};

export default EDC.Games.ImagesToTextSpace.Scenes.Main;
